import type { DashboardRole } from "@dashboard-auth"
import { requireDashboardCookieAuth } from "./dashboardSession"

export async function requireDashboardAuth(
  request: Request,
  roles: DashboardRole[] = ["admin", "editor", "viewer"]
) {
  return requireDashboardCookieAuth(request, roles)
}
